import React, { useState, useEffect } from 'react'
import { Box, Stack, CircularProgress, ListItem, ListItemText, List } from '@mui/material'
import getAgent from '@plug-core/utils/getAgent'
import { TopUp } from '@plug-core/clients/TopUp'
import { Principal } from '@dfinity/principal'
import { TopUp as TopUpItem } from '@plug-core/idls/topUp/topUp'
import useWallet from '@plug-core/hooks/useWallet'
import { formatNumber } from '@plug-core/utils/formatNumber'
import EmptyList from '@components/EmptyList'
import { useTranslation } from 'react-i18next'
import { format } from 'date-fns'

export const TopUpHistory = () => {
  const [history, setHistory] = useState<TopUpItem[]>([])
  const [loading, setLoading] = useState(true)

  const { wallet } = useWallet()

  const { t } = useTranslation()

  const loadHistory = async () => {
    setLoading(true)

    const agent = getAgent()
    const topUp = new TopUp(agent)
    const historyData = await topUp.getTopUpHistory(Principal.fromText(wallet.principalId))

    setHistory(historyData[0]?.history || [])
    setLoading(false)
  }

  useEffect(() => {
    loadHistory()
  }, [])

  return (
    <Box px={3}>
      {loading ? (
        <Stack alignItems="center" mt={5}>
          <CircularProgress />
        </Stack>
      ) : (
        <Stack component={List} spacing={2}>
          {history.length ? (
            history.reverse().map((item, index) => (
              <ListItem key={index}>
                <ListItemText
                  primary={t(`topup.types.${Object.keys(item.topup_type[0] || { Unknown: null })}`)}
                  secondary={item.canister.toString()}
                  secondaryTypographyProps={{ fontSize: 13, fontWeight: 400 }}
                />
                <ListItemText
                  primaryTypographyProps={{ textAlign: 'right' }}
                  secondaryTypographyProps={{ textAlign: 'right', fontSize: 13 }}
                  primary={formatNumber(Number(item.amount))}
                  secondary={format(new Date(Number(item.timestamp) / 1000000), 'dd.MM.yyyy')}
                />
              </ListItem>
            ))
          ) : (
            <EmptyList title={t('topupHistory.empty')} />
          )}
        </Stack>
      )}
    </Box>
  )
}
